import React, { Component } from "react";
import { Container } from "@mui/material";
import Button from "@material-ui/core/Button";
import FetchServerData from "../../../provider/FetchServerData";
import { PledgeThermometer_Url } from "../../../provider/ServiceUrl";
import Confetti from "react-confetti";
import Utils from "../../../provider/Utils";
import "./Pledge.css";
import HorizontalBar from "./HorizontalBar";

class LaunchHorizontalThermometer extends Component {
    constructor(props) {
        super(props);
        const str = new URLSearchParams(window.location.search);
        const urlTid = str.get("t");
        const pledgeId = str.get("p");
        this.state = {
            urlTid: urlTid,
            pledgeId: pledgeId,
            tollfreeNumber: "",
            bannerText: "",
            qrcodeimg: "",
            displayColor: {},
            donationList: [],
            measureType: null,
            fundraisingGoal: 0,
            totalDonation: 0,
            render: false,
            alerts: {},
            bannerImage: null,
            backgroundImage: null,
            donationUrl: "",
            isShowGoalAmount: false,
            is3dEffect: false,
            isConfetti: false,
            bannerTextColor: "",
            bannerBackground: "",
            backgroundImageURL: "none",
            horizontalMeterSettings: null,
        };
        // this.getThermometerDetails(urlTid, pledgeId);
    }

    componentDidMount() {
        this.setScrollSpeed();
        this.getThermometerDetails(this.state.urlTid, this.state.pledgeId);
        this.timerId = setInterval(
            () => this.getThermometerDetails(this.state.urlTid, this.state.pledgeId),
            10000
        );
    }

    componentWillUnmount() {
        clearInterval(this.timerId);
    }


    componentDidUpdate() {
        this.setScrollSpeed();
    }

    setScrollSpeed = () => {
        const itemCount = this.state.donationList.length;

        const baseDuration = 7; // for small list
        const duration = baseDuration + itemCount * 0.5; // adjust multiplier

        const container = document.querySelector(".scroll-content");

        if (container) {
            container.style.animationDuration = `${duration}s`;
        }
    };

    getThermometerDetails(urlTid, pledgeId) {
        FetchServerData.callGetServiceWithoutHeader(
            `${PledgeThermometer_Url}/${urlTid}/${pledgeId}`
        )
            .then((output) => {
                if (output.status === "SUCCESS") {
                    let messageDetails = output.data.smsMessage;
                    let pledgeDetails = messageDetails.pledgeDetails;
                    let horizontalMeterSettings = messageDetails.horizontalMeterSettings;
                    let tollfreeNumber = output.data.tollfreeNumber;
                    let qrcodeimg = output.data.qrCode;
                    for (let i = 0; i < pledgeDetails.donationList.length; i++) {
                        pledgeDetails.donationList[i].amount = Utils.formatWithCommas(
                            pledgeDetails.donationList[i].amount
                        );
                    }

                    const emptyDonation = {
                        firstName: "",
                        lastName: "",
                        email: "",
                        amount: null,
                        mobile: "",
                        ismanual: false,
                        isShowAnonymous: false,
                        createdon: null,
                        updatedon: null,
                        createdBy: null,
                        twilioIncomingMessageLogid: null,
                        twilioOutgoingMessageLogid: null,
                        source: null,
                        transactionId: null,
                        transactionDate: null,
                        paymentGateway: null,
                        updatedBy: null,
                        id: null,
                        contact: null,
                    };

                    // pad until there are 7 entries
                    while (pledgeDetails.donationList.length < 7) {
                        pledgeDetails.donationList.push({ ...emptyDonation });
                    }

                    this.setState({
                        pledgeId: pledgeDetails?.id,
                        offlineDonation: pledgeDetails.offlineDonation,
                        textDonation: pledgeDetails.textDonation,
                        totalDonation: pledgeDetails.totalDonation,
                        donationList: pledgeDetails.donationList,
                        isOptinkeyword: horizontalMeterSettings?.isOptinkeyword,
                        isAutoscroll: horizontalMeterSettings?.isAutoscroll,
                        isShowGoalAmount: horizontalMeterSettings?.isShowGoalAmount,
                        is3dEffect: horizontalMeterSettings?.is3dEffect,
                        isConfetti: horizontalMeterSettings?.isConfetti,
                        measureType: horizontalMeterSettings.measureType,
                        displayType: horizontalMeterSettings.displayType,
                        displayColor: horizontalMeterSettings.displayColor,
                        displayEffect: horizontalMeterSettings?.displayEffect,
                        displayStyle: horizontalMeterSettings.displayStyle,
                        bannerImage: horizontalMeterSettings?.bannerImage,
                        backgroundImage: horizontalMeterSettings?.backgroundImage,
                        backgroundImageURL: horizontalMeterSettings?.backgroundImage?.url
                            ? `url(${horizontalMeterSettings.backgroundImage.url.trim()})`
                            : "none",
                        donationUrl: horizontalMeterSettings?.donationUrl,
                        bannerText: horizontalMeterSettings?.bannerText,
                        bannerTextColor: horizontalMeterSettings?.bannerTextColor,
                        bannerBackground: horizontalMeterSettings?.bannerBackground,
                        meterFontColor: horizontalMeterSettings?.meterFontColor,
                        qrcodeimg: qrcodeimg,
                        tollfreeNumber: tollfreeNumber,
                        fundraisingGoal: horizontalMeterSettings?.goalAmount,
                        messageName: messageDetails?.messageName,
                        keyWord: messageDetails?.keyword,
                        render: true,
                    });
                } else {
                }
            })
            .catch((error) => { });
    }


    darkenColor = (hex, percent) => {
        if (!hex) return "#000000"; // Default to black if undefined

        // Remove the # if present
        hex = hex.replace(/^#/, "");

        // Convert to RGB
        let r = parseInt(hex.substring(0, 2), 16);
        let g = parseInt(hex.substring(2, 4), 16);
        let b = parseInt(hex.substring(4, 6), 16);

        // Decrease brightness
        r = Math.max(0, Math.floor(r * (1 - percent / 100)));
        g = Math.max(0, Math.floor(g * (1 - percent / 100)));
        b = Math.max(0, Math.floor(b * (1 - percent / 100)));

        // Convert back to HEX
        return `#${r.toString(16).padStart(2, "0")}${g
            .toString(16)
            .padStart(2, "0")}${b.toString(16).padStart(2, "0")}`;
    };

    safeNum = (val) => {
        const n = Number(val);
        return Number.isFinite(n) ? n : "";
    };

    truncateString = (str, maxLength) => {
        if (str.length <= maxLength) return str;
        const excess = str.length - maxLength;
        if (excess <= 3) return str;
        return str.slice(0, maxLength) + "...";
    };

    render() {
        if (this.state.render === false) {
            return <div />;
        } else {
            return (
                <>
                    {this.state.fundraisingGoal <= this.state.totalDonation && (
                        <>
                            {this.state.isConfetti && (
                                <Confetti gravity={0.1} wind={0} numberOfPieces={400} />
                            )}
                        </>
                    )}
                    <div style={{ background: "#fff", minHeight: "100vh" }}>
                        <div
                            className="row d-flex align-items-center justify-content-center pt-4"
                            style={{ background: "#fff" }}
                        >
                            <div className="col-md-10">
                                <div className="row mb-2" style={{ height: "100px" }}>
                                    <div className="col-8 col-md-8 text-start p-0" id="assetFormLabel">
                                        {this.state.bannerImage !== null && (
                                            <div
                                                style={{
                                                    display: "inline-flex",
                                                }}
                                            >
                                                <a href="https://givbee.net/" target="_blank">
                                                    <img
                                                        src={
                                                            this.state.bannerImage?.url
                                                                ? `${this.state.bannerImage.url}?v=${Date.now()}`
                                                                : ""
                                                        }
                                                        style={{
                                                            width: "100%",
                                                            height: "100px",
                                                            objectFit: "contain",
                                                            objectPosition: "left",
                                                        }}
                                                        alt="logo"
                                                    />
                                                </a>
                                            </div>
                                        )}
                                    </div>

                                    <div
                                        className="col-4 col-md-4 justify-content-end text-end align-self-end pe-0"
                                        id="assetFormLabel"
                                    >

                                        {this.state.donationUrl &&
                                            this.state.donationUrl.trim() !== "" &&
                                            (() => {
                                                let url = this.state.donationUrl.trim();
                                                if (!/^https?:\/\//i.test(url)) {
                                                    url = "https://" + url;
                                                }

                                                return (
                                                    <a
                                                        href={url}
                                                        target="_blank"
                                                        rel="noreferrer"
                                                        style={{ color: "#fff" }}
                                                    >
                                                        <Button
                                                            type="button"
                                                            variant="contained"
                                                            className="donateButton"
                                                        >
                                                            Donate
                                                        </Button>
                                                    </a>
                                                );
                                            })()}
                                    </div>
                                </div>
                                <div
                                    className="row"
                                    style={{
                                        fontSize: "26px",
                                        color: this.state.bannerTextColor,
                                        background: this.state.bannerBackground,
                                    }}
                                >
                                    <div className="col-md-12 text-center align-self-center p-1">
                                        <p className="large-2">
                                            {this.state.bannerText}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            className="row d-flex align-items-center justify-content-center"
                            style={{ background: "#fff" }}
                        >
                            <div
                                className="col-md-10"
                                style={{
                                    minHeight: "550px",
                                    backgroundImage: this.state.backgroundImageURL,
                                    backgroundSize: "cover",
                                    backgroundPosition: "center",
                                    backgroundRepeat: "no-repeat",
                                }}
                            >
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="row p-3">
                                            <div
                                                className="col-md-5 justify-content-center text-center"
                                            >
                                                {this.state.isShowGoalAmount && (
                                                    <span
                                                        className="fw-bold"
                                                        style={{
                                                            fontSize: "32px",
                                                            fontWeight: "600",
                                                            color: this.state.meterFontColor,
                                                        }}
                                                    >
                                                        Goal:{" "}
                                                        {`$${Utils.formatWithCommas(
                                                            this.state.fundraisingGoal
                                                        )}`}
                                                    </span>
                                                )}
                                            </div>
                                            <div className="col-md-7"></div>
                                        </div>
                                    </div>

                                    {this.state.displayStyle?.name === "HorizontalBar" && (
                                        <>
                                            <div
                                                className="col-md-5 align-content-center align-self-center text-center"
                                                style={{ maxHeight: "400px" }}
                                            >
                                                <div className="row horizontalBar">
                                                    <Container sx={{ textAlign: "center" }}>
                                                        <HorizontalBar
                                                            goal={this.state.fundraisingGoal}
                                                            raised={this.state.totalDonation}
                                                            color={this.state.displayColor?.hashColor}
                                                            displayType={this.state.displayStyle?.name}
                                                            isShowGoalAmount={this.state.isShowGoalAmount}
                                                            is3dEffect={this.state.is3dEffect}
                                                            measureType={this.state.measureType}
                                                            backgroundImage={this.state.backgroundImage}
                                                            meterFontColor={this.state.meterFontColor}
                                                        />
                                                    </Container>
                                                </div>
                                                <div className="row" style={{ position: "relative", top: "60px", }}>
                                                    <a
                                                        href="/"
                                                        target="_blank"
                                                        className="anchortag"
                                                        style={{
                                                            fontSize: "14px",
                                                            color: this.state.meterFontColor,
                                                        }}
                                                    >
                                                        Powered by GivBee
                                                    </a>
                                                </div>
                                            </div>
                                        </>
                                    )}

                                    <div className="col-md-7 text-center align-self-center">
                                        <div
                                            className="row donationListMoble"
                                            style={{
                                                color: this.state.meterFontColor,
                                                fontSize: "40px",
                                                height: "400px",
                                                lineHeight: "0.65em",
                                            }}
                                        >
                                            <div className="col-md-12">
                                                {/* {this.state.isAutoscroll ? ( */}
                                                <div className="scroll-container">
                                                    <div className="scroll-content">
                                                        {this.state.donationList.map((item, index) => (
                                                            <div
                                                                className="row p-3 d-flex m-0 text-start"
                                                                key={`item-${index}`}
                                                                style={{
                                                                    height: item.amount === null ? "60px" : "",
                                                                }}
                                                            >
                                                                {this.state.displayType?.type ===
                                                                    "FirstNameWithDonation" && (
                                                                        <>
                                                                            <div className="col-7 col-md-7 fw-bold text-start pe-0 align-self-center">
                                                                                {item.isShowAnonymous
                                                                                    ? "Anonymous"
                                                                                    : item.firstName}
                                                                            </div>
                                                                            <div className="col-5 col-md-5 fw-bold align-self-center">
                                                                                {" "}
                                                                                {item.amount !== null
                                                                                    ? `$${item.amount}`
                                                                                    : ""}
                                                                            </div>
                                                                        </>
                                                                    )}
                                                                {this.state.displayType?.type ===
                                                                    "FullNameNoDonation" && (
                                                                        <div className="col-7 col-md-7 fw-bold text-start pe-0 align-self-center">
                                                                            {item.isShowAnonymous
                                                                                ? "Anonymous"
                                                                                :
                                                                                `${item.firstName} ${item.lastName}`
                                                                            }
                                                                        </div>
                                                                    )}
                                                                {this.state.displayType?.type ===
                                                                    "FullNameWithDonation" && (
                                                                        <>
                                                                            <div className="col-7 col-md-7 fw-bold text-start pe-0 lh-1 align-self-center">
                                                                                {item.isShowAnonymous
                                                                                    ? "Anonymous"
                                                                                    :
                                                                                    `${item.firstName} ${item.lastName}`
                                                                                }
                                                                            </div>
                                                                            <div className="col-5 col-md-5 fw-bold align-self-center">
                                                                                {item.amount !== null
                                                                                    ? `$${item.amount}`
                                                                                    : ""}
                                                                            </div>
                                                                        </>
                                                                    )}
                                                                {this.state.displayType?.type ===
                                                                    "NoNameWithDonation" && (
                                                                        <>
                                                                            <div className="col-7 col-md-7 fw-bold text-start pe-0 align-self-center"></div>
                                                                            <div className="col-5 col-md-5 fw-bold align-self-center">
                                                                                {item.amount !== null
                                                                                    ? `$${item.amount}`
                                                                                    : ""}
                                                                            </div>
                                                                        </>
                                                                    )}
                                                            </div>
                                                        ))}
                                                        {this.state.donationList.map((item, index) => (
                                                            <div
                                                                className="row p-3 d-flex m-0 text-start"
                                                                key={`item-duplicate-${index}`}
                                                                style={{
                                                                    height: item.amount === null ? "60px" : "",
                                                                }}
                                                            >
                                                                {this.state.displayType?.type ===
                                                                    "FirstNameWithDonation" && (
                                                                        <>
                                                                            <div className="col-7 col-md-7 fw-bold text-start pe-0 align-self-center">
                                                                                {item.isShowAnonymous
                                                                                    ? "Anonymous"
                                                                                    : item.firstName}
                                                                            </div>
                                                                            <div className="col-5 col-md-5 fw-bold align-self-center">
                                                                                {item.amount !== null
                                                                                    ? `$${item.amount}`
                                                                                    : ""}
                                                                            </div>
                                                                        </>
                                                                    )}
                                                                {this.state.displayType?.type ===
                                                                    "FullNameNoDonation" && (
                                                                        <div className="col-7 col-md-7 fw-bold text-start pe-0 lh-1 align-self-center">
                                                                            {item.isShowAnonymous
                                                                                ? "Anonymous"
                                                                                :
                                                                                `${item.firstName} ${item.lastName}`}
                                                                        </div>
                                                                    )}
                                                                {this.state.displayType?.type ===
                                                                    "FullNameWithDonation" && (
                                                                        <>
                                                                            <div className="col-7 col-md-7 fw-bold text-start pe-0 lh-1 align-self-center">
                                                                                {item.isShowAnonymous
                                                                                    ? "Anonymous"
                                                                                    :
                                                                                    `${item.firstName} ${item.lastName}`}
                                                                            </div>
                                                                            <div className="col-5 col-md-5 fw-bold align-self-center">
                                                                                {item.amount !== null
                                                                                    ? `$${item.amount}`
                                                                                    : ""}
                                                                            </div>
                                                                        </>
                                                                    )}
                                                                {this.state.displayType?.type ===
                                                                    "NoNameWithDonation" && (
                                                                        <>
                                                                            <div className="col-7 col-md-7 fw-bold text-start pe-0 align-self-center"></div>
                                                                            <div className="col-5 col-md-5 fw-bold align-self-center">
                                                                                {" "}
                                                                                {item.amount !== null
                                                                                    ? `$${item.amount}`
                                                                                    : ""}
                                                                            </div>
                                                                        </>
                                                                    )}
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            );
        }
    }
}

export default LaunchHorizontalThermometer;
